import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import AssetNetworkIcon from '../asset-network-icon/AssetNetworkIcon';
import { useNetworkIcons } from './useNetworkIcons';
export const mapSwapCurreny = (item) => {
    const random = -1;
    //note : I created  this number becuase FIAT currencies dont have supportedNetwors
    // its only for the dev mode because there will be no fiat currencies on production
    const assetImg = _jsx(AssetNetworkIcon, { baseUrl: item.iconUrl });
    const networkCode = item.supportedNetworks[0]?.networkId || random;
    return {
        label: item.code,
        value: item.code + '-' + networkCode,
        icon: assetImg,
        networkId: networkCode,
        assetCode: item.code,
        networkCode: item.supportedNetworks[0]?.networkCode,
        roundingPrecision: item.roundingPrecision,
    };
};
export const useSwapAssetSelectOptions = (swapAssetArray) => {
    const networkIcons = useNetworkIcons();
    const arrayOfSelectedData = useMemo(() => swapAssetArray?.reduce((acc, asset) => {
        if (asset.supportedNetworks.length > 1) {
            return acc.concat(asset.supportedNetworks.map((network) => {
                const assetImg = (_jsx(AssetNetworkIcon, { baseUrl: asset.iconUrl, networkIcon: networkIcons[network.fireblocksId] }));
                return {
                    label: asset.code,
                    value: asset.code + '-' + network.networkId,
                    icon: assetImg,
                    description: network.networkName,
                    networkId: network.networkId,
                    assetCode: asset.code,
                    networkCode: network.networkCode,
                    roundingPrecision: asset.roundingPrecision,
                    fireblocksId: network.fireblocksId,
                };
            }));
        }
        else {
            return acc.concat(mapSwapCurreny(asset));
        }
    }, []) || [], [networkIcons, swapAssetArray]);
    return arrayOfSelectedData;
};
//# sourceMappingURL=useSwapAssetSelectOptions.js.map